import React from 'react';
import { Mail } from 'lucide-react'; // This component's personal "shopping list"

// googleoff-7d2e4a19 -- Google connection removed from the product; the inbox is
// Microsoft 365 only. Say so plainly instead of offering a button that can't work.
const EmailConnectScreen = ({ onConnectMicrosoft, error }) => {
    return (
        <div className="text-center p-10">
            <Mail size={48} className="mx-auto text-gray-400 mb-4" />
            <h2 className="text-2xl font-bold mb-2">Connect your Email Account</h2>
            <p className="text-gray-600 mb-2">Connect your email to send and receive messages directly from the CRM.</p>
            <p className="text-sm text-gray-500 mb-6">Spatchy's inbox works with Microsoft 365 / Outlook accounts. Gmail isn't supported.</p>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <div className="flex justify-center gap-4">
                 <button onClick={onConnectMicrosoft} className="flex items-center gap-2 px-4 py-2 bg-gray-700 text-white rounded-md font-semibold hover:bg-gray-800 transition-colors">
                     <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="currentColor" d="M11.4,24H0V12.6h11.4V24z M24,24H12.6V12.6H24V24z M11.4,11.4H0V0h11.4V11.4z M24,11.4H12.6V0H24V11.4z"/></svg>
                     Connect Microsoft 365 (Outlook)
                </button>
            </div>
        </div>
    )
}

export default EmailConnectScreen;
